import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ticker } from "@/components/site/Ticker";
import { Capabilities } from "@/components/site/Capabilities";
import { Manifesto } from "@/components/site/Manifesto";
import { Stats } from "@/components/site/Stats";
import { Gallery } from "@/components/site/Gallery";
import { Safety } from "@/components/site/Safety";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#050B14] text-white">
      <Nav />
      <Hero />
      <Ticker />
      <Capabilities />
      <Manifesto />
      <Stats />
      <Gallery />
      <Safety />
      <Contact />
      <Footer />
    </main>
  );
}
